import React from 'react';
// import { GoogleMap } from '@react-google-maps/api';
import { MapContext } from '@react-google-maps/api';

class Spiderfy extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);

    this.oms = new oms.OverlappingMarkerSpiderfier(
      MapContext._currentValue, // 1*  was=GoogleMap().MapContext._currentValue
      { circleFootSeparation: 50, legWeight: 1, spiralLengthStart: 20 },
    );

    // store markers by child index so we can remove them on unmount
    this._markerByIndex = {};
    this.markerNodeRef = this.markerNodeRef.bind(this);
  }

  markerNodeRef(ref, idx) {
    // called both for mount (ref !== null) and unmount (ref === null)
    // on mount: wait until ref.marker exists and add it to oms
    if (ref) {
      // ensure we don't add the same marker twice
      const addIfReady = () => {
        if (!ref || !ref.marker) {
          // try again later if marker not ready
          setTimeout(addIfReady, 250);
          return;
        }
        const marker = ref.marker;
        // avoid duplicates
        if (this._markerByIndex[idx] === marker) return;
        // if there was a previous marker for this index remove it
        if (this._markerByIndex[idx] && this._markerByIndex[idx] !== marker) {
          try {
            this.oms.removeMarker(this._markerByIndex[idx]);
          } catch (e) {}
        }
        this._markerByIndex[idx] = marker;
        this.oms.addMarker(marker);
        // attach spider_click once
        if (!marker.__spiderfy_listener_attached) {
          window.google.maps.event.addListener(marker, 'spider_click', (e) => {
            if (this.props.onSpiderClick) this.props.onSpiderClick(e);
          });
          marker.__spiderfy_listener_attached = true;
        }
      };
      addIfReady();
    } else {
      // unmount: remove stored marker for this child idx
      const prev = this._markerByIndex[idx];
      if (prev) {
        try {
          this.oms.removeMarker(prev);
        } catch (e) {}
        delete this._markerByIndex[idx];
      }
    }
  }

  render() {
    // Only attempt to clone valid React elements (skip strings/nulls)
    return React.Children.map(this.props.children, (child, idx) => {
      if (!React.isValidElement(child)) {
        return child; // leave non-elements (like strings or null) as-is
      }
      return React.cloneElement(child, { ref: (r) => this.markerNodeRef(r, idx) });
    });
  }
}

export default Spiderfy;

// note
// 1*
// if your are not able to get thecontext of google map then you can use MapContext._currentValue
// and import it instead of Google map i.e ( import { MapContext } from "@react-google-maps/api"; )

// 2*
// if you are not able to get the value with ref.marker then it can be ref.state.marker

// 3*
// I am using setTimeout as a hack it could be more better but FYI if marker took time to load and you are have trouble with // // markers refs then you can use setTimeout !!! but its not an ideal solution but it works
